function initRefreshStatusImport() {

    const container = $('.refresh-invoice')
    const jobID = container.data('job-id')
    if (container.length > 0) {
        $.getJSON(`/admin/invoices/refresh_status?job_id=${jobID}`, function(data) {
            container.html(data.message)
            if (data.pct < 100) {
                setTimeout(initRefreshStatusImport, 1000);
            } else if (data.pct === 100) {
                window.location.reload();
            }
        });
    }
}

export { initRefreshStatusImport }